/* eslint-disable */
import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const staffList = myKey => new Promise((resolve, reject) => {

  if (!myKey || myKey === 'undefined' || myKey === undefined ||
      myKey === 'null' || myKey === null) return

  let key = sanitize(myKey)
  key = encodeURIComponent(key)
  const uri = `?options=json&valid=${key}`

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_STAFF_LIST_ENDPOINT + uri)
    .then(response => {
      resolve(response.data.answer.results.staff)
    })
    .catch(error => {
      reject(error)
    })
})
